import type { MicroSurvey, MicroSurveyOption, MicroSurveySubmission } from '../model/types';

import type { paths } from '@/types/api';

type MicroSurveyPath = paths['/v2/users/me/micro-survey'];

export type WireMicroSurvey = NonNullable<
  MicroSurveyPath['get']['responses']['200']['content']['application/json']['data']
>;

type WireMicroSurveyOption = WireMicroSurvey['options'][number];

export type WireMicroSurveySubmission =
  MicroSurveyPath['post']['requestBody']['content']['application/json'];

const toMicroSurveyOption = ({
  value,
  label,
  additionalInfoPrompt,
  additionalInfoPlaceholder,
}: WireMicroSurveyOption): MicroSurveyOption => ({
  value,
  label,
  ...(additionalInfoPrompt !== undefined && { additionalInfoPrompt }),
  ...(additionalInfoPlaceholder !== undefined && { additionalInfoPlaceholder }),
});

/** The survey the API offers, as the popup shows it. */
export const toMicroSurvey = ({ type, question, options }: WireMicroSurvey): MicroSurvey => ({
  type,
  question,
  options: options.map(toMicroSurveyOption),
});

/**
 * A submission as the API takes it. Fields the hook left out stay out, so a
 * close sends only `surveyType` and `closed`, as it always has.
 */
export const toWireMicroSurveySubmission = ({
  surveyType,
  response,
  additionalInfo,
  closed,
}: MicroSurveySubmission): WireMicroSurveySubmission => ({
  surveyType,
  ...(response !== undefined && { response }),
  ...(additionalInfo !== undefined && { additionalInfo }),
  ...(closed !== undefined && { closed }),
});
